import { SportsMenuDisciplineWithTranslationsDto } from 'types/swagger';
import { FEED_LIVENAV } from 'lib/ssr/live-nav/types';
import type { feedLiveNavActionType } from 'lib/ssr/live-nav/types';

export const feedLiveNav = (payload: SportsMenuDisciplineWithTranslationsDto): feedLiveNavActionType => ({
  type: FEED_LIVENAV,
  payload,
});